// src/hooks/usePageContent.js
import { useState } from 'react';
import { getSubscriptionPackage } from '../services/appService';

const useSubscriptionPackage = () => {
    const [status, setStatus] = useState('idle'); // idle | loading | done | error
    const [error, setError] = useState('');
    const [data, setData] = useState([]);

    const fetchSubscriptionPackage = async (invId) => {
        setStatus('loading');
        setError('');

        try {
            const response = await getSubscriptionPackage(invId);

            if (response?.status !== 'Error') {
                setData(response); // depending on API shape
                setStatus('done');
            } else {
                setStatus('error');
                setError(response?.message || 'Something went wrong');
            }
        } catch (err) {
            setStatus('error');
            setError(err?.message || 'Something went wrong');
        }
    };

    const resetStatus = () => {
        setStatus('idle');
        setError('');
    };

    return {
        fetchSubscriptionPackage,
        data,
        status,
        error,
        resetStatus
    };
};

export default useSubscriptionPackage;
